(() => {
  const requests = new Map();
  const widgets = new WeakSet();
  const config = document.querySelector('#st-strings');
  const strings = config ? JSON.parse(config.textContent) : {};
  const selector = '.jdgm-review-widget[data-id], .jdgm-review-widget[data-product-id]';

  function latestReviews(productId) {
    if (!requests.has(productId)) {
      const url = new URL('https://api.judge.me/reviews/reviews_for_widget');
      url.search = new URLSearchParams({
        shop_domain: 'pantone-us.myshopify.com', platform: 'shopify',
        product_id: productId, page: '1', per_page: '20', sort_by: 'created_at', sort_dir: 'desc'
      });
      requests.set(productId, fetch(url, { credentials: 'omit', signal: AbortSignal.timeout(10000) })
        .then(response => {
          if (!response.ok) throw new Error('Review lookup unavailable');
          return response.json();
        }).then(data => {
          if (typeof data.html !== 'string') throw new Error('Unexpected review response');
          const doc = new DOMParser().parseFromString(data.html, 'text/html');
          const reviews = [...doc.querySelectorAll('.jdgm-rev[data-review-id]')]
            .sort((a, b) => Date.parse(b.querySelector('time')?.dateTime) - Date.parse(a.querySelector('time')?.dateTime))
            .slice(0, 20);
          return new Map(reviews.map(review => [review.dataset.reviewId,
            review.querySelector('.jdgm-rev__location')?.textContent.trim() || '']));
        }).catch(() => null));
    }
    return requests.get(productId);
  }

  function setup(widget) {
    if (widgets.has(widget)) return;
    const productId = widget.dataset.id || widget.dataset.productId;
    if (!/^[1-9]\d*$/.test(productId || '')) return;
    widgets.add(widget);
    let recentIds = null;
    let scheduled = false;
    function update() {
      scheduled = false;
      widget.querySelectorAll('.jdgm-rev[data-review-id]').forEach(review => {
        const recent = recentIds?.has(review.dataset.reviewId);
        const previous = review.querySelector('.st-review-recent');
        if (recent && !previous) {
          const label = document.createElement('span');
          label.className = 'st-review-recent';
          label.textContent = strings.recent || 'Reviewed Recently';
          const timestamp = review.querySelector('.jdgm-rev__timestamp');
          if (timestamp) timestamp.after(label);
          else review.querySelector('.jdgm-rev__header')?.append(label);
        } else if (!recent && previous) previous.remove();
        const locationText = recentIds?.get(review.dataset.reviewId);
        let location = review.querySelector('.jdgm-rev__location');
        // Initial Shopify widget HTML may predate the enabled location setting.
        if (locationText && !location?.textContent.trim()) {
          if (!location) {
            location = document.createElement('span');
            location.className = 'jdgm-rev__location';
            review.querySelector('.jdgm-rev__header')?.append(location);
          }
          location.textContent = locationText;
        }
        review.querySelectorAll('.st-incentive').forEach(label => label.remove());
        review.querySelectorAll('[data-badge-type="review_earned_for_future_purchase"]').forEach(badge => {
          if (!badge.textContent.trim()) badge.textContent = strings.incentivised || 'Review earned a reward for future purchase';
        });
      });
    }
    function schedule() {
      if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
    }
    new MutationObserver(schedule).observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-review-id'] });
    update();
    latestReviews(productId).then(ids => { recentIds = ids; schedule(); });
  }

  document.querySelectorAll(selector).forEach(setup);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches(selector)) setup(node);
      node.querySelectorAll(selector).forEach(setup);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();